var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossCircleSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #c83232;\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,400C0,179.1,179.1,0,400,0s400,179.1,400,400-179.1,400-400,400S0,620.9,0,400ZM262.6,193.9c-19-19-49.7-19-68.7,0-19,19-19,49.7,0,68.7l137.4,137.4-137.4,137.4c-19,19-19,49.7,0,68.7,19,19,49.7,19,68.7,0l137.4-137.4,137.4,137.4c19,19,49.7,19,68.7,0,19-19,19-49.7,0-68.7l-137.4-137.4,137.4-137.4c19-19,19-49.7,0-68.7-19-19-49.7-19-68.7,0l-137.4,137.4-137.4-137.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCircleSolid);
export default __webpack_public_path__ + "static/media/cross-circle-solid.031f9205b51cbf5ed4ee28097d7495c6.svg";
export { ForwardRef as ReactComponent };